
export enum RiskLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL'
}

export type Language = 'zh' | 'en';

export interface ClauseAnalysis {
  clauseId: string;
  originalText: string;
  category: string;
  riskLevel: RiskLevel;
  riskDescription: string;
  suggestedAction: string;
  revisedText: string;
  thoughtChain?: string; // 思维链，用于展示分析过程
  legalReferences?: string[]; // 相关法律条款引用
}

export interface LegalReference {
  title: string;
  article: string;
  content: string;
  url?: string;
}

export interface Contract {
  id: string;
  name: string;
  uploadDate: string;
  status: 'pending' | 'analyzing' | 'completed' | 'error';
  clauses: ClauseAnalysis[];
  summary?: string;
  fullContent?: string[]; // 存储原始文档的所有段落
  displayHtml?: string;   // 存储用于显示的 HTML 内容 (A4 样式)
  storagePath?: string;   // Supabase Storagepath
  legalReferences?: LegalReference[]; // 相关法律条款引用
}

export interface AnalysisState {
  isAnalyzing: boolean;
  progress: number;
  currentClauseIndex: number;
}

// Pre-analysis configuration types
export type ReviewPosition = 'partyA' | 'partyB';
export type ReviewIntensity = 'aggressive' | 'neutral' | 'defensive';

export interface ReviewConfig {
  position: ReviewPosition;
  intensity: ReviewIntensity;
  policyId?: string;
  policyContent?: string;
}

// Preview state before analysis
export interface PreviewState {
  fileName: string;
  content: string[];
  htmlContent?: string;
  fileObject?: File; // 用于上传的文件对象
  isReady: boolean;
}
